import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-markdata',
  templateUrl: './markdata.component.html',
  styleUrls: ['./markdata.component.scss'],
})
export class MarkdataComponent implements OnInit {
  data={
    comment:"",
    type:""
  }
  constructor() { }

  ngOnInit() {}

}
